import { FieldSet } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { actions } from 'Data/ReduxViewModels/PsdSieveAnalysis';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, ButtonGroup, Field, RadioGroup } from '../../../Core';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';

let RefreshSievesAdditionButton: React.FC = () => {
  const dispatch = useDispatch();

  const isRefreshingSieves = useSelector((s) => s.psdSieveAnalysis.refreshSieves.status.submitting);
  const isWorksheetSaving = useSelector((s) => s.worksheetEditor.status.saving);
  return (
    <Button
      disabled={isRefreshingSieves || isWorksheetSaving}
      loading={isRefreshingSieves}
      onClick={() => dispatch(actions.refreshSieves())}
    >
      Refresh Sieves
    </Button>
  );
};

/**
 * Renders a component for nominating how to add sieve sizes
 * and providing a control to refresh the sieves on a worksheet.
 *
 * This is consistent across all PSD Sieve Analysis worksheets
 */
let SieveAdditionFieldSet: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const isSieveBasedOnSpecification = useSelector(
    pipe(createWorksheetSelector!('AddSieveSizesBasedOnSpecification'), valueOrDefault(false))
  );

  return (
    <FieldSet>
      {/* 
      While this is a boolean setting, we have decided to present this as a radio group 
      to better communicate the options with the appropriate option set (even if the field is NULL)
      */}
      <Field input={<RadioGroup />} name={'AddSieveSizesBasedOnSpecification'} value={isSieveBasedOnSpecification} />

      <ButtonGroup>
        <RefreshSievesAdditionButton />
      </ButtonGroup>
    </FieldSet>
  );
};

SieveAdditionFieldSet = withInjectedProps(SieveAdditionFieldSet);

export { RefreshSievesAdditionButton, SieveAdditionFieldSet };
